// @flow
import { useQuery, type QueryResult } from 'react-query';
import { transporters as transportersApi } from 'common/middleware/api';

import { TransporterId } from 'common/models/internal/TransporterId';

type Params = {
    clientId: string,
    includeInactive?: boolean
};

type Result = Array<{ transporterId: TransporterId, name: string }>;

export const fetchTransporters = async ({
    clientId,
    includeInactive = false
}: Params): Promise<Result> => {
    const response = await transportersApi.fetch({ clientId, includeInactive });

    return response.transporters.map(({ transporterId, status, name }) => ({
        transporterId: TransporterId.fromJS(transporterId),
        status,
        name
    }));
};

export default function useTransporters({
    clientId,
    includeInactive = false
}: Params): QueryResult<Result> {
    return useQuery({
        queryKey: ['personnel', 'transporters', 'all', { includeInactive }],
        queryFn: () => fetchTransporters({ clientId, includeInactive })
    });
}
